"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var GanttChart_1 = require("../GanttChart");
var edit_icon_svg_1 = __importDefault(require("res/img/edit-icon.svg"));
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var GanttChartProjectTask = function (_a) {
    var task = _a.task, style = _a.style, onTaskResizeStart = _a.onTaskResizeStart, onTaskReorderStart = _a.onTaskReorderStart, disableDrag = _a.disableDrag, resizing = _a.resizing, reordering = _a.reordering, onDelete = _a.onDelete, onEdit = _a.onEdit, historic = _a.historic;
    var taskResizeStart = function (direction) {
        if (historic)
            return;
        onTaskResizeStart(task, direction);
    };
    var taskReorderStart = function (e) {
        if (historic)
            return;
        var target = e.target;
        if (document.body.getAttribute('data-resizing') === 'true')
            return;
        if (target.classList.contains('grab-control'))
            return;
        if (reordering)
            return;
        onTaskReorderStart(task);
    };
    var taskEditStart = function (e) {
        if (historic)
            return;
        onEdit({ x: e.clientX, y: e.clientY }, task);
    };
    return (react_1.default.createElement("div", { className: 'gantt-chart-project-task', "data-task-type": task.taskType, onMouseDown: taskReorderStart, onTouchStartCapture: taskReorderStart, "data-resizing": resizing, "data-reordering": reordering, "data-historic": historic, style: style },
        react_1.default.createElement("div", { className: 'gantt-chart-project-task__info flex flex-row' },
            react_1.default.createElement("span", { className: 'gantt-chart-project-task__label' },
                task.taskName,
                task.assignedUser && " - " + task.assignedUser.firstName + " " + task.assignedUser.lastName),
            !historic &&
                react_1.default.createElement("button", { type: 'button', title: 'Edit Task', "aria-label": 'Edit Task', onClick: taskEditStart, className: 'edit-button' },
                    react_1.default.createElement("img", { src: edit_icon_svg_1.default, alt: 'Edit' })),
            !historic &&
                react_1.default.createElement("button", { type: 'button', "aria-label": 'Delete Task', title: 'Delete Task', onClick: function () { return onDelete(task); }, className: 'edit-button' },
                    react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Close Icon' }))),
        !historic &&
            disableDrag !== GanttChart_1.Directions.BACKWARDS &&
            react_1.default.createElement("div", { className: 'gantt-chart-project-task__grab-control grab-control__back', onTouchStartCapture: function () { return taskResizeStart(GanttChart_1.Directions.BACKWARDS); }, onMouseDown: function () { return taskResizeStart(GanttChart_1.Directions.BACKWARDS); } }),
        !historic &&
            disableDrag !== GanttChart_1.Directions.FORWARDS &&
            react_1.default.createElement("div", { className: 'gantt-chart-project-task__grab-control grab-control__forwards', onTouchStartCapture: function () { return taskResizeStart(GanttChart_1.Directions.FORWARDS); }, onMouseDown: function () { return taskResizeStart(GanttChart_1.Directions.FORWARDS); } })));
};
exports.default = GanttChartProjectTask;
